export default __webpack_public_path__ + "static/media/checkmark.08bb7be1.svg";